(() => {
  if (window.__cloudSearchPresearchRowsInit) return;
  window.__cloudSearchPresearchRowsInit = true;

  let isMutating = false;

  function getPrimaryUrl(dt) {
    return (
      dt.querySelector(
        'a.cs-product-link[href], a[href*="/products/"], a[href*="/collections/"], a[href*="/pages/"], a[id$="-name"][href]'
      )?.href || dt.querySelector('a.list-image[href]')?.href
    );
  }

  function isTitleLink(anchor) {
    const href = anchor.getAttribute('href') || '';
    return (
      anchor.id?.endsWith('-name') ||
      anchor.classList.contains('cs-item-title') ||
      anchor.classList.contains('cs-product-link') ||
      href.includes('/collections/') ||
      href.includes('/pages/')
    );
  }

  /** Cloud Search sometimes outputs multiple title links; flex column stacks them on separate lines */
  function mergeTitleLinks(details) {
    const links = [...details.querySelectorAll(':scope > a[href]')].filter(isTitleLink);
    if (links.length <= 1) return;

    const primary = links[0];
    const fragment = document.createDocumentFragment();

    links.forEach((link, index) => {
      if (index > 0) fragment.appendChild(document.createTextNode(' '));
      while (link.firstChild) fragment.appendChild(link.firstChild);
    });

    isMutating = true;
    links.slice(1).forEach((link) => link.remove());
    primary.textContent = '';
    primary.appendChild(fragment);
    isMutating = false;
  }

  /** Cloud Search preview descriptions sometimes start with empty <br> tags, adding dead space */
  function stripLeadingBreaks(root) {
    root.querySelectorAll('dd .description').forEach((desc) => {
      let node = desc.firstChild;
      while (node) {
        const next = node.nextSibling;
        const isEmptyText = node.nodeType === Node.TEXT_NODE && !node.textContent.trim();
        const isBreak = node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR';
        if (!isEmptyText && !isBreak) break;
        isMutating = true;
        node.remove();
        isMutating = false;
        node = next;
      }
    });
  }

  function bindRow(dt) {
    mergeTitleLinks(dt.querySelector('.cs-item-details') || dt);

    if (dt.dataset.rowClickBound) return;
    const url = getPrimaryUrl(dt);
    if (!url) return;

    dt.dataset.rowClickBound = 'true';
    dt.addEventListener('click', (event) => {
      if (event.defaultPrevented) return;
      if (event.target.closest('a[href]')) return;
      window.location.assign(url);
    });
  }

  function syncRoot(root) {
    root.querySelectorAll('dt.cs-item').forEach(bindRow);
    stripLeadingBreaks(root);
  }

  function bind(root) {
    if (!root || root.dataset.rowsBound) return;
    root.dataset.rowsBound = 'true';
    syncRoot(root);

    new MutationObserver(() => {
      if (isMutating) return;
      syncRoot(root);
    }).observe(root, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('#cloud-search-results, .cloud-search-results').forEach(bind);

    new MutationObserver(() => {
      document.querySelectorAll('#cloud-search-results, .cloud-search-results').forEach((el) => {
        if (!el.dataset.rowsBound) bind(el);
        else syncRoot(el);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
